<div class="row fonte-Corpo">
  <div class="col-12 col-sm-12 col-md-12 col-xl-12">
    <nb-card>
      <nb-card-header>
        <div class="row mb-3">
          <div class="col-md-3">
            <h3 class="fonte-Cabecalho">{{ 'Meus Orçamentos' | translate }}</h3>
          </div>
        </div>

        <div class="row p-3">
          <div class="col-12">
            <div class="alert alert-danger" role="alert" *ngIf="mensagemErro && erroAoBuscar">
              {{mensagemErro}}
            </div>
          </div>
        </div>

        <div class="row">
          <!-- <form class="col-12 col-md-12 row" novalidate (keydown.enter)="$event.preventDefault()"> -->
            <div class="col-12 mb-2 col-md-2 align-self-center">
              <input autocomplete="off" type="text" class="form-control" name="orcamento" [(ngModel)]="filtro.id"
                placeholder="{{ 'N°' | translate }} {{ 'Orçamento' | translate }}" />
            </div>
            <div class="col-12 mb-2 col-md-2 align-self-center">
              <input autocomplete="off" type="text" class="form-control" name="localizador"
                [(ngModel)]="filtro.localizador" placeholder="{{ 'Localizador' | translate}}" />
            </div>
            <div class="col-12 mb-2 col-md-2 align-self-center">
              <input autocomplete="off" type="text" class="form-control" name="pax" [(ngModel)]="filtro.pax"
                placeholder="{{ 'Nome' | translate }} {{ 'Pax' | translate }}" />
            </div>
            <div class="col-12 mb-2 col-md-2 align-self-center" *ngIf="usuarioLogado?.EmpresaId > 0">
              <typeahead name="ConsultorAutoComplete" [lista]="data" [searchText]="Consultor.Nome"
                (searchFunction)="onChangeConsultor($event)" (selectItem)="selecionaConsultor($event)">
                <input autocomplete="off" class="form-control input-sm" [(ngModel)]="Consultor.Nome" name="consultor"
                  placeholder="{{ 'Consultor' | translate }}" />
              </typeahead>
            </div>
            <div class="col-12 mb-2 col-md-2 align-self-center">
              <select class="form-control" [(ngModel)]="filtro.TipoLoc" name="tipoloc">
                <option value="" [selected]="true">{{'Tipo de Loc.' | translate}}</option>
                <option value="Aereo">{{'Aéreo' | translate}}</option>
                <option value="Hotel">{{'Hotel' | translate}}</option>
                <option value="Servico">{{'Serviço' | translate}}</option>
                <option value="Seguro">{{'Seguro' | translate}}</option>
                <option value="Carro">{{'Carro' | translate}}</option>
                <option value="Casa">{{'Casa' | translate}}</option>
                <option value="Circuito">{{'Circuito' | translate}}</option>
                <option value="Beto">{{'Beto Carrero' | translate}}</option>
              </select>
            </div>
            <!-- <div class="col-lg-auto col-md-2">
                <a [nbPopover]="templateCia" nbPopoverPlacement="bottom" class="fonte-Filtros" href="javascript:;">
                  Situações <i class="fas fa-chevron-down"></i>
                </a>
                <ng-template #templateCia id="templateCia" >
                  <div style=" padding:10px; min-width: 350px; max-width: 768px;">
                    <nb-card class="inline-form-card">
                      <nb-card-header>Situações</nb-card-header>
                      <nb-card-body>
                        <div class="validation-checkboxes">
                         <input class="m-2" type="checkbox" (change)="filtroStatus('-1')" [checked]="filtro.situacao.length == 0" /><label>Todos</label>
                         <input class="m-2" type="checkbox" (change)="filtroStatus('5')" [checked]="filtroStatusChecked('5')" /><label>Pagos</label>
                         <input class="m-2" type="checkbox" (change)="filtroStatus('0')" [checked]="filtroStatusChecked('0')" /><label>Pendentes</label>
                       </div>
                      </nb-card-body>
                    </nb-card>

                  </div>
                </ng-template>
              </div> -->

            <!-- <div class="col-lg-auto col-md-4 row">
                <nb-checkbox class="m-2" (checkedChange)="filtroStatus('-1')" [value]="filtro.situacao.length == 0" > Todos</nb-checkbox>
                <nb-checkbox class="m-2" (checkedChange)="filtroStatus('5')" [value]="filtroStatusChecked('5')" >Pagos</nb-checkbox>
                <nb-checkbox class="m-2" (checkedChange)="filtroStatus('0')" [value]="filtroStatusChecked('0')" >Pendentes</nb-checkbox>
              </div> -->

            <nb-radio-group [(ngModel)]="filtro.situacao" name="situacao"
              class="col-md-2 align-items-center mobile-flex align-self-center" style="font-weight:normal">
              <nb-radio [value]="-1">{{ 'Todos' | translate }}</nb-radio>
              <nb-radio [value]="6">{{ 'Pagos' | translate }}</nb-radio>
              <option [value]="1">{{ 'Pré-Pagamento' | translate }}</option>
              <nb-radio [value]="0">{{ 'Pendentes' | translate }}</nb-radio>
            </nb-radio-group>

          <!-- </form> -->
        </div>
        
        <div class="row">
          <div class="col-md-2 align-self-center has-calendar-icon">
            <input class="form-control" nbInput [placeholder]="'Criado De' | translate" [nbDatepicker]="ngmodel"
              autocomplete="off" [(ngModel)]="Data3" onkeydown="return false">
            <nb-datepicker format="DD/MM/YYYY" #ngmodel (dateChange)="setDate($event)"></nb-datepicker>
          </div>

          <div class="col-md-2 align-self-center has-calendar-icon">
            <input autocomplete="off" class="form-control" nbInput [(ngModel)]="Data4"
              [placeholder]="'Criado Ate' | translate" [nbDatepicker]="ngmodel1" onkeydown="return false" />
            <nb-datepicker format="DD/MM/YYYY" #ngmodel1 [min]="Data3" (dateChange)="setDate($event)">
            </nb-datepicker>
          </div>

          <!-- <div class="col-12 mb-2 col-md-2 col-md-2 align-self-center">
            <input autocomplete="off" type="text" class="form-control" name="agencia" [(ngModel)]="filtro.AgenciaNome"
              placeholder="{{ 'Agência' | translate }}" />
          </div> -->

          <!-- <nb-radio-group [(ngModel)]="filtro.StatusReserva" name="statusreserva"
            class="col-md-3 row m-0 p-0 align-items-center mobile-flex align-self-center"
            style="font-weight:normal; max-width: 220px">
            <nb-radio class="col-6 p-0" [value]="-1">{{ 'Todos' | translate }}</nb-radio>
            <nb-radio class="col-6 p-0" [value]="3">{{ 'Reservados' | translate }}</nb-radio>
            <nb-radio class="col-6 p-0" [value]="5">{{ 'Emitidos' | translate }}</nb-radio>
            <nb-radio class="col-6 p-0" [value]="8">{{ 'Cancelados' | translate }}</nb-radio>
          </nb-radio-group> -->

          <div class="col-12 mb-2 col-md-2 align-self-center">
            <select class="form-control" style="padding-left: 10px;" [(ngModel)]="filtro.StatusReserva" name="statusreserva">
              <option [value]="-1">{{ 'Status Res. (Todos)' | translate }}</option>
              <option [value]="3">{{ 'Reservados' | translate }}</option>
              <option [value]="5">{{ 'Emitidos' | translate }}</option>
              <option [value]="8">{{ 'Cancelados' | translate }}</option>
            </select>
          </div>

          <div class="col-md-2 align-self-center mobile-center">
            <button type="button" (click)="erroAoBuscar = true; buscarMeusOrcamentos()" class="btn btn-success"><i
                class="fa fa-search"></i></button>
            <!-- <img width="100px" src="assets/img/loading1.gif" /> -->
          </div>

          <div class="d-flex w-100 justify-content-center mt-3 font-mobile mb-gray d-block d-md-none">
            <input type="checkbox" name="filtroPax" id="filtroPax" [(ngModel)]="filtroPax"
              (ngModelChange)="filtrarPax($event)" style="height: 17px; margin-right: 1rem;">
            <label style="height: 20px; margin: 0" for="filtroPax">{{"Apenas Orçamento com Pax" | translate}}</label>
          </div>
        </div>
      </nb-card-header>


      <nb-card-body class="d-md-block d-none">
        <nb-list style="overflow: hidden !important">
          <nb-list-item class="row fonte-tabela-orcamentos mobile-hidden">
            <div class="text-center col-lg-1">
              {{ 'Orçamento' | translate }}
            </div>
            <div class="text-center col-lg-2">
              {{ 'Pax' | translate }}
            </div>
            <div class="text-center col-lg-2">
              {{ 'Agente' | translate }}
            </div>
            <div class="text-center col-lg-2">
              {{ 'Agência' | translate }}
            </div>
            <div class="text-center col-lg-1">
              {{ 'Empresa' | translate }}
            </div>
            <div class="text-center col-lg-1">
              {{ 'Consultor' | translate }}
            </div>
            <div class="text-center col-lg-1">
              {{ 'Data' | translate }}
            </div>
            <div class="text-center col-lg-1">
              {{ 'Itens' | translate }}
            </div>
            <div class="text-center col-lg-1">
              {{ 'Situação' | translate }}
            </div>
          </nb-list-item>

          
          <nb-list-item (click)="acessarOrcamento(reserva)"
            class="row fonte-tabela-orcamentos-dados align-items-center click mobile-gap"
            *ngFor="let reserva of orcamentos">
            <div class="col-lg-1 text-center">
              {{reserva.Id}}
            </div>
            <div class="col-lg-2 text-center text-capitalize">
              {{reserva.Pax}}
            </div>
            <div class="col-lg-2 text-center text-capitalize">
                {{reserva.Agente?.Nome}}
            </div>
            <div class="col-lg-2 text-center text-capitalize">
                {{reserva.Agencia?.NomeFantasia}}
            </div>
            <div class="col-lg-1 text-center text-capitalize">
              {{reserva.Agencia?.Empresa?.NomeFantasia}}
            </div>
            <div class="col-lg-1 text-center text-capitalize">
                {{reserva.Consultor?.Nome}} {{reserva.Consultor?.Sobrenome}}
            </div>
            <div class="col-lg-1 text-center">
                {{reserva.Alteracoes.CriadoEm | date:'dd/MM/yy HH:mm'}}
            </div>
            <div class="col-md-1 text-center">
              <i [hidden]="!(reserva.Aereos?.length > 0)" class="fa fa-plane fa-rotate-270" title="Aéreo"
                style="margin-right: 4px;"></i>
              <i [hidden]="!(reserva.Hoteis?.length > 0)" class="fa fa-hotel" title="Hotel"
                style="margin-right: 4px;"></i>
              <i [hidden]="!(reserva.Transfers?.length > 0)" class="fas fa-bus " title="Tranfer"
                style="margin-right: 4px;"></i>
              <i [hidden]="!(reserva.Tickets?.length > 0)" class="fas fa-ticket-alt" title="Ticket"
                style="margin-right: 4px;"></i>
              <i [hidden]="!(reserva.Servicos?.length > 0)" class="fas fa-bus" title="Serviços"
                style="margin-right: 4px;"></i>
              <i [hidden]="!(reserva.Carros?.length > 0)" class="fa fa-car " title="Carro"
                style="margin-right: 4px;"></i>
              <i [hidden]="!(reserva.Seguros?.length > 0)" class="fas fa-shield-alt" title="Seguro"
                style="margin-right: 4px;"></i>
              <i [hidden]="!(reserva.PacoteReservas?.length > 0)" class="fas fa-suitcase" title="pacote"
                style="margin-right: 4px;"></i>
              <i [hidden]="!(reserva.Casas?.length > 0)" class="fa fa-home" title="casa" style="margin-right: 4px;"></i>
              <i [hidden]="!(reserva.Circuitos?.length > 0)" class="fa fa-globe" title="circuito"
                style="margin-right: 4px;"></i>
              <i [hidden]="!(reserva.BetoCarreroIngressos?.length > 0)" class="fa fa-hat-cowboy-side" title="Beto Carrero"
                style="margin-right: 4px;"></i>
            </div>
            <div class="col-md-1 text-center">
              <div [ngSwitch]="reserva.Status">
                <span *ngSwitchCase="0" class="badge badge-pill badge-primary min-size">{{ 'Pendente' | translate
                  }}</span>
                <span *ngSwitchCase="1" class="badge badge-pill badge-primary min-size">{{ 'Pré-Pagamento' | translate
                  }}</span>
                <span *ngSwitchCase="6" class="badge badge-pill badge-info min-size">{{'Pago' | translate }}</span>
              </div>
            </div>
          </nb-list-item>
       


        <!-- <nb-list-item (click)="acessarOrcamento(reserva)"
        class="row fonte-tabela-orcamentos-dados align-items-center click mobile-gap"
        *ngFor="let reserva of orcamentos">
        <div class="col-lg-1 text-center">
          {{reserva.Id}}
        </div>
        <div class="col-lg-2 text-center text-capitalize">
          {{reserva.Pax}}
        </div>
        <div class="col-lg-2 text-center text-capitalize">
          {{reserva.Agente}}
        </div>
        <div class="col-lg-2 text-center text-capitalize">
          {{reserva.Agencia}}
        </div>
        <div class="col-lg-1 text-center text-capitalize">
          {{reserva.Empresa}}
        </div>
        <div class="col-lg-1 text-center text-capitalize">
          {{reserva.Consultor}}
        </div>
        <div class="col-lg-1 text-center">
          {{reserva?.CriadoEm | date:'dd/MM/yy HH:mm'}}
        </div>
        <div class="col-md-1 text-center">
          <i [hidden]="!(reserva.Aereo > 0)" class="fa fa-plane fa-rotate-270" title="Aéreo"
            style="margin-right: 4px;"></i>
          <i [hidden]="!(reserva.Hotel > 0)" class="fa fa-hotel" title="Hotel"
            style="margin-right: 4px;"></i>
          <i [hidden]="!(reserva.Transfer > 0)" class="fas fa-bus " title="Tranfer"
            style="margin-right: 4px;"></i>
          <i [hidden]="!(reserva.Ticket > 0)" class="fas fa-ticket-alt" title="Ticket"
            style="margin-right: 4px;"></i>
          <i [hidden]="!(reserva.Servico > 0)" class="fas fa-bus" title="Serviços"
            style="margin-right: 4px;"></i>
          <i [hidden]="!(reserva.Carro > 0)" class="fa fa-car " title="Carro"
            style="margin-right: 4px;"></i>
          <i [hidden]="!(reserva.Seguro > 0)" class="fas fa-shield-alt" title="Seguro"
            style="margin-right: 4px;"></i>
          <i [hidden]="!(reserva.Pacote > 0)" class="fas fa-suitcase" title="pacote"
            style="margin-right: 4px;"></i>
          <i [hidden]="!(reserva.Casa > 0)" class="fa fa-home" title="casa" style="margin-right: 4px;"></i>
          <i [hidden]="!(reserva.Circuito > 0)" class="fa fa-globe" title="circuito"
            style="margin-right: 4px;"></i>
        </div>
        <div class="col-md-1 text-center">
          <div [ngSwitch]="reserva.Status">
            <span *ngSwitchCase="0" class="badge badge-pill badge-primary min-size">{{ 'Pendente' | translate
              }}</span>
            <span *ngSwitchCase="1" class="badge badge-pill badge-primary min-size">{{ 'Pré-Pagamento' | translate
              }}</span>
            <span *ngSwitchCase="6" class="badge badge-pill badge-info min-size">{{'Pago' | translate }}</span>
          </div>
        </div>
      </nb-list-item> -->

        </nb-list>
        <paginacao [paginacao]="paginacao" (alterarPagina)="buscarPagina($event)"></paginacao>
      </nb-card-body>


      <nb-card-body class="d-block d-md-none container p-0">
        <div class="table-striped">
          <table class="table fonte-tabela-orcamentos">
            <tr>
              <td class="text-center pt-3 pb-3 pl-0 pr-0"> {{ "Orçamento" | translate }} </td>
              <td class="text-center pt-3 pb-3 pl-0 pr-0 "> {{ "Data" | translate }} </td>
              <td class="text-center pt-3 pb-3 pl-0 pr-0"> {{ "Itens" | translate }} </td>
              <td class="text-center pt-3 pb-3 pl-0 pr-0"> {{ "Situação" | translate }} </td>
              <td class="text-center pt-3 pb-3 pl-0 pr-0"> {{ "Info" | translate }} </td>
            </tr>

            <tr *ngFor="let reserva of orcamentos; let i = index;">
              <td class="col-2 text-center"><a (click)="acessarOrcamento(reserva)">{{reserva.Id}}</a> </td>
              <td class="col-2 text-center"> <a (click)="acessarOrcamento(reserva)">{{reserva.CriadoEm |
                  date:'dd/MM/yy HH:mm'}}</a>
              </td>
              <td class="col-3 text-center">
                <a (click)="acessarOrcamento(reserva)">
                  <i [hidden]="!(reserva.Aereos?.length > 0)" class="fa fa-plane fa-rotate-270" title="Aéreo"
                    style="margin-right: 4px;"></i>
                  <i [hidden]="!(reserva.Hoteis?.length > 0)" class="fa fa-hotel" title="Hotel"
                    style="margin-right: 4px;"></i>
                  <i [hidden]="!(reserva.Transfers?.length > 0)" class="fas fa-bus " title="Tranfer"
                    style="margin-right: 4px;"></i>
                  <i [hidden]="!(reserva.Tickets?.length > 0)" class="fas fa-ticket-alt" title="Ticket"
                    style="margin-right: 4px;"></i>
                  <i [hidden]="!(reserva.Servicos?.length > 0)" class="fas fa-bus" title="Serviços"
                    style="margin-right: 4px;"></i>
                  <i [hidden]="!(reserva.Carros?.length > 0)" class="fa fa-car " title="Carro"
                    style="margin-right: 4px;"></i>
                  <i [hidden]="!(reserva.Seguros?.length > 0)" class="fas fa-shield-alt" title="Seguro"
                    style="margin-right: 4px;"></i>
                  <i [hidden]="!(reserva.PacoteReservas?.length > 0)" class="fas fa-suitcase" title="pacote"
                    style="margin-right: 4px;"></i>
                  <i [hidden]="!(reserva.Casas?.length > 0)" class="fa fa-home" title="casa"
                    style="margin-right: 4px;"></i>
                  <i [hidden]="!(reserva.Circuitos?.length > 0)" class="fa fa-globe" title="circuito"
                    style="margin-right: 4px;"></i>
                </a>
              </td>
              <td class="col-3 text-center">
                <a (click)="acessarOrcamento(reserva)">
                  <div [ngSwitch]="reserva.Status">
                    <span *ngSwitchCase="0" class="badge badge-pill badge-primary min-size">{{ 'Pendente' | translate
                      }}</span>
                    <span *ngSwitchCase="1" class="badge badge-pill badge-primary min-size">{{ 'Pré-Pagamento' |
                      translate }}</span>
                    <span *ngSwitchCase="6" class="badge badge-pill badge-info min-size">{{'Pago' | translate }}</span>
                  </div>
                </a>
              </td>
              <td class="col-2 text-center">
                <a (click)="abrirModal(modalInfo, reserva)"><i class="fa fa-info"></i></a>
              </td>
            </tr>
          </table>
        </div>
        <paginacao [paginacao]="paginacao" (alterarPagina)="buscarPagina($event)" [mobile]="true"></paginacao>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<ng-template let-modal #modalInfo let-c="close">
  <div class="modal-content">
    <div class="modal-header">
      <div class="font-mobile bold roboto maior ml-3">
        {{"Orçamento" | translate}}: {{itemReserva?.Id}}
      </div>
      <button type="button" class="close close-mobile pt-2" data-dismiss="modal" aria-label="Close"
        (click)="c('Close')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="text-left text-capitalize">
        Pax:
        <b>{{(itemReserva?.Pax != undefined && itemReserva?.Pax != null && itemReserva?.Pax?.length > 3) ?
          itemReserva?.Pax : 'Vazio' | translate}}</b>
      </div><br>
      <div class="text-left text-capitalize">
        Agente:
        <b>{{itemReserva?.Agente?.Nome?.length > 0 ? itemReserva?.Agente?.Nome : 'Vazio' | translate}}
        </b>
      </div><br>
      <div class="text-left text-capitalize">
        Agencia: <b>{{itemReserva?.Agencia?.NomeFantasia}}
        </b></div><br>
      <div class="text-left text-capitalize">
        Empresa: <b>{{itemReserva?.Agencia?.Empresa?.NomeFantasia}}
        </b></div><br>
      <div class="text-left text-capitalize">
        Consultor: <b
          *ngIf="itemReserva?.ConsultorId > 0">{{itemReserva?.Consultor?.Nome}}{{itemReserva?.Consultor?.Sobrenome}}
        </b>
        <b *ngIf="!itemReserva?.ConsultorId">{{'Vazio' | translate}}</b>
      </div>
    </div>
  </div>
</ng-template>
